<div fxLayout="column" fxLayoutGap="10px" >
  <h2 class="page-header left">Scheduled Task Status</h2>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" #tableContainer class="table-height table-flex">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="lastExecutionTime" matSortDirection="desc">

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext-left">
           <span>
                {{element.name}}
           </span>
        </td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext-left">
           <span>
                {{element.description}}
           </span>
        </td>
      </ng-container>

      <!-- Frequency Column -->
      <ng-container matColumnDef="frequency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Frequency </th>
        <td mat-cell  class="cell-width-mtext-left" *matCellDef="let element">
          {{element.frequency}}
        </td>
      </ng-container>

      <!-- Last Execution Time Column -->
      <ng-container matColumnDef="lastExecutionTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Execution </th>
        <td mat-cell  class="cell-width-mtext-left" *matCellDef="let element">
          {{element.lastExecutionTime | date: 'long'}}
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator
    [pageSize]="pageSizes[0]"
    [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>

